import React, { createContext, useContext, useState } from 'react';
import { MOCK_DATA } from '../data/mockData';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [userRole, setUserRole] = useState('PM_OFFICE'); // Options: PM_OFFICE, OMA_USER, PUBLIC
  const [data, setData] = useState(MOCK_DATA);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <AppContext.Provider value={{ 
      userRole, 
      setUserRole, 
      data, 
      sidebarOpen, 
      toggleSidebar 
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);